import React, { createContext, useState, useEffect } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Initialize language state from localStorage or default to 'en'
  const [language, setLanguage] = useState(() => {
    const savedLang = localStorage.getItem('preferredLanguage');
    return savedLang ? savedLang : 'en';
  });

  // Function to toggle language
  const toggleLanguage = () => {
    setLanguage(prevLang => (prevLang === 'en' ? 'ur' : 'en'));
  };

  // Update localStorage whenever language changes
  useEffect(() => {
    localStorage.setItem('preferredLanguage', language);
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};